import {createElement, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';
import ShopProvider from 'rlink-shop/service/base';
import PurchaseModal from 'rlink-shop/components/PurchaseModal';
import NavLink from 'rlink-router/NavLink.jsx';

export default function BuyButton ({css, isDisabled, identifier, isPreorder, purchaseIdentifier, productData, service, ratingsBoard, purchaseModalContent}) {

  if (isDisabled) {
    return null;
  }

  let prePurchaseLabel = <FormattedMessage
    id="ui.label.button.PRE_PURCHASE_LABEL"
    defaultMessage="Pre-Purchase"
    description="Button label for pre purchasing a shop item." />;

  let buyNowLabel = <FormattedMessage
    id="ui.label.button.BUY_NOW_LABEL"
    defaultMessage="Buy Now"
    description="Button for buying a shop item." />;

  let purchaseHref = () => {
    let data = {
      identifier,
      purchaseIdentifier,
    };
    if (productData) {
      data.productID = productData.productID;
    }
    if (purchaseModalContent) {
      data.purchaseModalContent = <PurchaseModal
        css={css}
        content={purchaseModalContent}
        ratingsBoard={ratingsBoard} />;
    }

    return service.getPurchaseHref(data);
  };

  return (
    <NavLink href={purchaseHref()}
      id={`buy-${identifier}`}
      className={`${css.btn} ${css['button-accent']}`}>
      {(isPreorder) ? prePurchaseLabel : buyNowLabel}
    </NavLink>
  );
}

BuyButton.propTypes = {
  css: PropTypes.object,
  isDisabled: PropTypes.bool,
  identifier: PropTypes.string,
  isPreorder: PropTypes.bool,
  purchaseIdentifier: PropTypes.string,
  productData: PropTypes.object,
  service: PropTypes.instanceOf(ShopProvider),
  ratingsBoard: PropTypes.object,
  purchaseModalContent: PropTypes.node,
};



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/BuyButton.jsx